import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'global',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'tabs/add',
      tab: {
        type: 'Reports',
        id: 'Reports',
        stock_report_id: 'legacy_work_hours',
        name: 'Reports',
        viewPath: '/App/Account/Content/Reports',
      },
    })
  }
}
